module.exports = __webpack_public_path__ + "static/media/wonder-video.b2253814.mp4";